import { EBrowser, EDesktopOS, EDeviceScreenWidth, EMobileOS } from "./DeviceStateEnums";
import { IDeviceDynamicState, IDeviceState } from "./DeviceStateInterfaces";
import { TDeviceOS } from "./DeviceStateTypes";

export default class DeviceStateService {


  private static _f: DeviceStateService | null = null;
  public static get factory(): DeviceStateService {
    if (this._f != null) return this._f; this._f = new DeviceStateService();
    return this._f;
  }


  constructor() {
    //this.addOrientationListener()
  }


  public userAgent: string = navigator.userAgent || navigator.vendor //|| window.opera


  //#region deviceTypes
  public isMobileDevice = (): boolean => {
    const regexs = [/(Android)(.+)(Mobile)/i, /BlackBerry/i, /iPhone|iPod/i, /Opera Mini/i, /IEMobile/i]
    const result = regexs.some((b) => this.userAgent.match(b))
    return result;
  }

  public isTabletDevice = (): boolean => {
    const regex = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/
    return regex.test(this.userAgent.toLowerCase())
  }

  public isDesktopDevice = (): boolean => !this.isMobileDevice() && !this.isTabletDevice()
  //#endregion


  //#region OS
  public getMobileOS = (): EMobileOS | undefined => {
    if (this.isMobileDevice()) {
      // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(this.userAgent)) return EMobileOS.WindowsPhone
      else if (/android/i.test(this.userAgent)) return EMobileOS.Android

      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      //if (/iPad|iPhone|iPod/.test(this.userAgent) && !window.MSStream) return EMobileOS.iOS

      return EMobileOS.Unknown
    } else return undefined
  }

  public getDesktopOS = (): EDesktopOS | undefined => {
    if (this.isDesktopDevice()) {
      if (this.userAgent.indexOf('Win') !== -1) return EDesktopOS.Windows
      else if (this.userAgent.indexOf('Mac') !== -1) return EDesktopOS.MacOS
      else if (this.userAgent.indexOf('X11') !== -1) return EDesktopOS.Unix
      else if (this.userAgent.indexOf('Linux') !== -1) return EDesktopOS.Linux

      return EDesktopOS.Unknown;
    } else return undefined;
  }

  private getDeviceOS = (): TDeviceOS | undefined => this.getMobileOS() ?? this.getDesktopOS()

  private mobileOS: EMobileOS | undefined = this.getMobileOS();
  private isAndroidDevice = this.getDeviceOS() === EMobileOS.Android;
  private isAppleDevice = this.getDeviceOS() === EMobileOS.iOS || this.getDeviceOS() === EDesktopOS.MacOS;
  private isUnknownMobileDevice = this.getDeviceOS() === EMobileOS.Unknown;

  private desktopOS: EDesktopOS | undefined = this.getDesktopOS();
  private isWindowsDesktop = this.getDeviceOS() === EDesktopOS.Windows;
  private isLinuxOrUnixDesktop = this.getDeviceOS() === EDesktopOS.Linux || this.getDeviceOS() === EDesktopOS.Unix;
  //#endregion


  //#region orientation
  private get supportedScreenOrientation(): OrientationType { return (screen?.orientation || {}).type ?? (screen as any).mozOrientation ?? (screen as any).msOrientation }
  public get safariScreenOrientation(): OrientationType { return !screen?.orientation && matchMedia('(orientation: portrait)').matches ? 'portrait-primary' : 'landscape-primary' }


  //private initialScreenOrientation = this.supportedScreenOrientation ?? this.safariScreenOrientation ?? 'portrait-primary'
  public get screenOrientation(): OrientationType {
    return this.supportedScreenOrientation //?? this.safariScreenOrientation ?? 'portrait-primary' 
  }
  // public setOrientation(ev: Event) {
  //   //this.screenOrientation = (ev.target ?? ({} as any)).type;
  // }
  // private addOrientationListener() {
  //     //this.screenOrientation = screen.orientation.type;
  //     //if (screen.orientation) {

  //     screen.orientation.removeEventListener('deviceorientation', (ev: Event) => {
  //       this.setOrientation(ev)
  //     });
  //     screen.orientation.addEventListener('deviceorientation', (ev: Event) => {
  //       this.setOrientation(ev)
  //     });
  //   //}
  // }


  private get isLandscapeOrientation(): boolean {
    const result = ['landscape-primary', 'landscape-secondary'].includes(this.screenOrientation)
    return result;
  }
  private get isPortraitOrientation(): boolean {
    const result = ['portrait-primary', 'portrait-secondary'].includes(this.screenOrientation)
    return result;
  }
  //#endregion


  //#region screenSize
  // public getScreenSize(): number[] {
  //   const result = [window.innerWidth, window.innerHeight];
  //   return result;
  // }

  public getScreenWidth(): number {
    return window.innerWidth
  }
  public getScreenHeight(): number {
    return window.innerHeight
  }

  public getEDeviceScreenState(): EDeviceScreenWidth {
    let screenWidht = this.getScreenWidth();
    if (screenWidht >= 1200) return EDeviceScreenWidth.ExtraLarge;
    if (screenWidht >= 922) return EDeviceScreenWidth.Large;
    if (screenWidht >= 768) return EDeviceScreenWidth.Medium;
    if (screenWidht >= 500) return EDeviceScreenWidth.Small;
    return EDeviceScreenWidth.Tiny;
  }
  //#endregion


  //#region getBrowserInfo
  public currentBrowserIsOneOfGivenBrowsers(enums: EBrowser[]): boolean {
    const eCurrentBrowser = this.getBrowserInfo()
    const result = enums.find((it) => it == eCurrentBrowser)
    return (result != undefined) 
  }


  public getBrowserInfo(): EBrowser {
    const userAgent = navigator.userAgent;

    if (userAgent.includes("Chrome") && !userAgent.includes("Edge") && !userAgent.includes("OPR")) {
        return EBrowser.GoogleChrome;
    } else if (userAgent.includes("Firefox")) {
        return  EBrowser.Firefox;
    } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
        return EBrowser.Safari;
    } else if (userAgent.includes("Edge")) {
        return EBrowser.Edge;
    } else if (userAgent.includes("OPR") || userAgent.includes("Opera")) {
        return EBrowser.Opera;
    } else if (userAgent.includes("MSIE") || userAgent.includes("Trident")) {
        return EBrowser.InternetExplorer;
    } else {
        return EBrowser.Unknown;
    }
  }
  //endregion

  public getDeviceDynamicState(): IDeviceDynamicState {
    return {
      eDeviceScreenState: this.getEDeviceScreenState(),
      screenWidth: this.getScreenWidth(),
      screenHeight: this.getScreenHeight(),
      isLandscapeOrientation: () => this.isLandscapeOrientation,
      isPortraitOrientation: () => this.isPortraitOrientation
    }
  }


  public getDeviceState(): IDeviceState {
    return {
      isDesktop: this.isDesktopDevice(),
      desktopOS: this.desktopOS,
      isWindowsDesktop: this.isWindowsDesktop,
      isLinuxOrUnixDesktop: this.isLinuxOrUnixDesktop,
      isMobile: this.isMobileDevice(),
      mobileOS: this.mobileOS,
      isAndroidDevice: this.isAndroidDevice,
      isAppleDevice: this.isAppleDevice,
      isUnknownMobileDevice: this.isUnknownMobileDevice,
      isTablet: this.isTabletDevice(),
      isLandscapeOrientation: () => this.isLandscapeOrientation,
      isPortraitOrientation: () => this.isPortraitOrientation
    }
  }
}